<template>
  <ul>
    <li>
      <div class="oblea" @click="clickOblea">

        <div id="imageContainer">
          <img id="imagenProducto" :src="imagenProducto" style="width: 50px" /> 
        </div>

        <div id="textContainer">
          <p id="titulo">{{item.Nombre}}</p>
          <p class="observacion">{{item.Observacion}}</p>
        </div>

        
      </div>
    </li>
  </ul>
</template>

 
<script>
import axios from 'axios'

  export default {
    name: 'item-descuentoHome',
    props: ['item'],

    data() {
      return {
        imagenProducto: null  
      }
    },  

    watch: {
      item: {
        immediate: true,
        handler  () {
          this.getImage()
        }
      }
    },



    methods: {

      clickOblea: function () {
         this.$router.push({ name: 'Descuentos' });
      },

      getImage () {
        if (this.item.ArchivosId.length != 0)
        {
          var img = this.$store.state.pedido.imagenes.find( e => e.id === this.item.ArchivosId[0]);
          if (img != null)
          {
            this.imagenProducto = img.image
          } 
          else
          {
            let config = {
              method: 'GET',
              responseType: 'blob',
              url:'/WebSalesArchivo?ArchivoId='+this.item.ArchivosId[0]+'&Ancho=150',
              headers: {
                          Token:this.$store.state.user.token,
                          ClientSecret: process.env.CLIENT_SECRET,
                          EmpresaId: process.env.EMPRESA_ID
                       }
              }
            axios
            .request(config)
            .then(response => {
              let reader = new FileReader()
              reader.onload = () => {
                this.imagenProducto = reader.result
                var img = {id:this.item.ArchivosId[0],image:this.imagenProducto} 
                this.$store.commit('pedido/saveImage',img)   
              }
              console.log(response.data)
              reader.readAsDataURL(response.data)
            })
            .catch(err => console.log(err))
          }
        }         
      },



    }

  }
</script>


<style scoped>

  * {
   margin:  0;
   padding: 0;
  }
        
  li {
   display: block;
   text-decoration: none;
  }
        
  .oblea{
    width: 190px;
    height: 42px;
    border-width: 1px;
    border: 1px solid #dddddd;
    background: #ffffff;
    padding: 10px 15px 10px 15px;
    box-shadow: 2px 2px 4px #dddddd;  
    -webkit-box-shadow: 2px 2px 4px #dddddd;  
    -moz-box-shadow:    2px 2px 4px #dddddd;  
    margin-bottom: 15px;
    display: flex;
    flex-direction: row;

   }

.oblea:hover{
    cursor: pointer;
  }      


#imageContainer{
  width: 20%;
  display: flex;
  flex-direction: row;
  justify-content: center;  
  align-items: center;
}

#textContainer{
  width: 80%;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;  
  align-items: center;
}

#titulo{
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  font-size: 11px; 
  font-weight: 500;
  text-align: center
}


.observacion{
  margin-top: 5px;
  padding-left: 10px;
  padding-top: 2px;
  font-size: 8px; 
  text-align: justify;
  overflow: hidden;
  position: relative; 
  line-height: 1em;
  max-height: 2em; 
  text-align: justify;
  margin-right: -1em;
  padding-right: 1em;
}


.observacion:before {
  content: '...';
  position: absolute;
  right: 0;
  bottom: 0;
}


.observacion:after {
  content: '';
  position: absolute;
  right: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.2em;
  background: white;
}
        
        
</style>


// WEBPACK FOOTER //
// src/components/views/home/itemDescuentoHome.vue